import * as React from "react";
import { Icon } from "../actions/Icon";
import { Button } from "../actions/Button";

/**
 * Share link in mono with a Copy button that confirms with "Copied".
 */
export interface LinkFieldProps {
  /** Shown in mono, without the scheme ("grackle.app/v/8fK2") */
  url: string;
  /** Full URL put on the clipboard. Default "https://" + url */
  href?: string;
  onCopy?: () => void;
  size?: "md" | "sm";
  className?: string;
}

export function LinkField({ url, href, onCopy, size = "md", className }: LinkFieldProps): JSX.Element {
  const [copied, setCopied] = React.useState(false);
  const timer = React.useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  React.useEffect(() => () => clearTimeout(timer.current), []);
  const copy = () => {
    try {
      void navigator.clipboard?.writeText(href ?? "https://" + url).catch(() => {});
    } catch {
      // Clipboard API unavailable (insecure context); the URL stays selectable.
    }
    setCopied(true);
    onCopy?.();
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 1800);
  };
  return (
    <div className={["gk-link", size === "sm" && "gk-link--sm", className].filter(Boolean).join(" ")}>
      <div className="gk-link__url">
        {size !== "sm" && <Icon name="link-simple" />}
        <span>{url}</span>
      </div>
      <Button
        size="lg"
        icon={copied ? "check" : size === "sm" ? undefined : "copy"}
        onClick={copy}
      >
        {copied ? "Copied" : "Copy"}
      </Button>
    </div>
  );
}
